import React, { useState, useCallback } from "react";
import "./SystemSetting.scss";

// ─── Icons ───────────────────────────────────────────────────────────────────
const Ico = {
  Mobile: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  Matrix: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M9 9h.01M15 9h.01M9 15h.01M15 15h.01" />
    </svg>
  ),
  Files: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  Notif: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  ),
  WhatsApp: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6z" />
    </svg>
  ),
  Retain: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Save: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Test: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  Eye: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  EyeOff: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ),
  Refresh: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
  ),
  Copy: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  ),
  Warn: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  Info: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  XCircle: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
  Plus: (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Spinner: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  Check: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
};

// ─── Toggle component ─────────────────────────────────────────────────────────
const Toggle = ({ checked, onChange, disabled, color }) => (
  <label className={`ss-toggle${color ? ` ${color}` : ""}`}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
    />
    <span />
  </label>
);

// ─── Masked token input ───────────────────────────────────────────────────────
const TokenField = ({ label, value, onChange, onRotate }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="ss-field">
      <label>{label}</label>
      <div className="ss-token-row">
        <input
          className={`ss-input ss-token-row__input${show ? "" : " masked"}`}
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="••••••••••••••••••••"
        />
        <div className="ss-token-row__actions">
          <button
            className="ss-btn ss-btn--ghost"
            style={{ padding: "7px 10px" }}
            onClick={() => setShow((v) => !v)}
            title={show ? "Hide" : "Show"}
          >
            {show ? Ico.EyeOff : Ico.Eye}
          </button>
          <button
            className="ss-btn ss-btn--ghost"
            style={{ padding: "7px 10px" }}
            onClick={() => navigator.clipboard?.writeText(value)}
            title="Copy"
          >
            {Ico.Copy}
          </button>
          {onRotate && (
            <button
              className="ss-btn ss-btn--ghost"
              style={{ padding: "7px 10px" }}
              onClick={onRotate}
              title="Rotate"
            >
              {Ico.Refresh}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// ─── Test Connection ──────────────────────────────────────────────────────────
const TestConnection = ({ label, onTest }) => {
  const [state, setState] = useState("idle"); // idle | testing | success | error
  const run = async () => {
    setState("testing");
    await new Promise((r) => setTimeout(r, 1800));
    setState(Math.random() > 0.2 ? "success" : "error");
    setTimeout(() => setState("idle"), 4000);
  };
  return (
    <div className="ss-test-wrap">
      <button
        className="ss-btn ss-btn--secondary"
        onClick={run}
        disabled={state === "testing"}
      >
        {state === "testing" ? (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {Ico.Spinner} Testing…
          </span>
        ) : (
          <>
            {Ico.Test} Test {label}
          </>
        )}
      </button>
      {state === "success" && (
        <div className="ss-test-result ss-test-result--success">
          {Ico.Check} Connected successfully
        </div>
      )}
      {state === "error" && (
        <div className="ss-test-result ss-test-result--error">
          {Ico.Warn} Connection failed
        </div>
      )}
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════════
// TAB PANELS
// ═══════════════════════════════════════════════════════════════════════════════

// ─── 1. Mobile App ────────────────────────────────────────────────────────────
function MobileTab({ cfg, onChange, dirty }) {
  return (
    <>
      <div className="ss-impact-banner ss-impact-banner--warn">
        {Ico.Warn}
        <span>
          <strong>Caution:</strong> Changes to the minimum app version will
          force older app users to update before they can login.
        </span>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(0,98,254,0.10)", color: "#0062FE" }}
          >
            {Ico.Mobile}
          </div>
          <div>
            <div className="ss-card__header-title">Version & Maintenance</div>
            <div className="ss-card__header-subtitle">
              Control minimum supported version and app-wide maintenance mode
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-form-grid" style={{ marginBottom: 16 }}>
            <div className="ss-field">
              <label>Minimum App Version</label>
              <input
                className="ss-input"
                value={cfg.minVersion}
                onChange={(e) => onChange("minVersion", e.target.value)}
                placeholder="e.g. 1.0.0"
              />
            </div>
            <div className="ss-field">
              <label>Current Latest Version</label>
              <input
                className="ss-input"
                value={cfg.latestVersion}
                onChange={(e) => onChange("latestVersion", e.target.value)}
                placeholder="e.g. 1.3.2"
              />
            </div>
          </div>
          <div className="ss-setting-row">
            <div className="ss-setting-row__info">
              <div className="ss-setting-row__label">Maintenance Mode</div>
              <div className="ss-setting-row__desc">
                Show a maintenance message to all mobile users. They will not be
                able to log in.
              </div>
            </div>
            <div className="ss-setting-row__control">
              <Toggle
                checked={cfg.maintenanceMode}
                onChange={(v) => onChange("maintenanceMode", v)}
                color="red"
              />
            </div>
          </div>
          {cfg.maintenanceMode && (
            <div className="ss-field" style={{ marginTop: 12 }}>
              <label>Maintenance Message</label>
              <textarea
                className="ss-textarea"
                value={cfg.maintenanceMsg}
                onChange={(e) => onChange("maintenanceMsg", e.target.value)}
                placeholder="System is under maintenance. Please try again later."
              />
            </div>
          )}
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(139,92,246,0.10)", color: "#8B5CF6" }}
          >
            {Ico.Mobile}
          </div>
          <div>
            <div className="ss-card__header-title">Feature Flags</div>
            <div className="ss-card__header-subtitle">
              Enable or disable mobile app features globally
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          {[
            {
              key: "fileSharing",
              label: "File Sharing",
              desc: "Allow users to send files and attachments in rooms",
            },
            {
              key: "voiceNotes",
              label: "Voice Notes",
              desc: "Allow recording and sending voice note messages",
            },
            {
              key: "reactions",
              label: "Message Reactions",
              desc: "Allow emoji reactions on messages",
            },
            {
              key: "screenshotPrev",
              label: "Screenshot Prevention",
              desc: "Block screenshots on sensitive screens (Android enforced)",
            },
            {
              key: "biometricAuth",
              label: "Biometric Login",
              desc: "Allow Face ID / Fingerprint login on supported devices",
            },
          ].map((f) => (
            <div key={f.key} className="ss-setting-row">
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">{f.label}</div>
                <div className="ss-setting-row__desc">{f.desc}</div>
              </div>
              <div className="ss-setting-row__control">
                <Toggle
                  checked={!!cfg.features?.[f.key]}
                  onChange={(v) =>
                    onChange("features", { ...cfg.features, [f.key]: v })
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ─── 2. Matrix / Synapse ──────────────────────────────────────────────────────
function MatrixTab({ cfg, onChange }) {
  return (
    <>
      <div className="ss-impact-banner ss-impact-banner--info">
        {Ico.Info}
        <span>
          Matrix tokens are masked and cannot be revealed in full. Use{" "}
          <strong>Rotate</strong> to generate a new token — this will disconnect
          active clients temporarily.
        </span>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(0,98,254,0.10)", color: "#0062FE" }}
          >
            {Ico.Matrix}
          </div>
          <div>
            <div className="ss-card__header-title">Homeserver Connection</div>
            <div className="ss-card__header-subtitle">
              Matrix/Synapse server URL and admin credentials
            </div>
          </div>
          <div className="ss-card__header-actions">
            <span className="ss-status ss-status--healthy">Healthy</span>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-form-grid" style={{ marginBottom: 16 }}>
            <div className="ss-field">
              <label>Homeserver URL</label>
              <input
                className="ss-input"
                value={cfg.homeserverUrl}
                onChange={(e) => onChange("homeserverUrl", e.target.value)}
                placeholder="https://matrix.internal"
              />
            </div>
            <div className="ss-field">
              <label>Server Name</label>
              <input
                className="ss-input"
                value={cfg.serverName}
                onChange={(e) => onChange("serverName", e.target.value)}
                placeholder="murasal.local"
              />
            </div>
          </div>
          <TokenField
            label="Admin Access Token"
            value={cfg.adminToken}
            onChange={(v) => onChange("adminToken", v)}
            onRotate={() => alert("Rotating admin token…")}
          />
          <TestConnection label="Matrix Connection" />
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(139,92,246,0.10)", color: "#8B5CF6" }}
          >
            {Ico.Matrix}
          </div>
          <div>
            <div className="ss-card__header-title">Room Defaults</div>
            <div className="ss-card__header-subtitle">
              Default settings applied when creating new Matrix rooms
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-form-grid" style={{ marginBottom: 0 }}>
            <div className="ss-field">
              <label>Default Room Version</label>
              <select
                className="ss-select"
                value={cfg.defaultRoomVersion}
                onChange={(e) => onChange("defaultRoomVersion", e.target.value)}
              >
                {["9", "10", "11"].map((v) => (
                  <option key={v}>{v}</option>
                ))}
              </select>
            </div>
            <div className="ss-field">
              <label>Default History Visibility</label>
              <select
                className="ss-select"
                value={cfg.historyVisibility}
                onChange={(e) => onChange("historyVisibility", e.target.value)}
              >
                {["shared", "invited", "joined", "world_readable"].map((v) => (
                  <option key={v}>{v}</option>
                ))}
              </select>
            </div>
          </div>
          {[
            {
              key: "encryptByDefault",
              label: "Encrypt rooms by default",
              desc: "Enable E2EE for all newly created rooms",
            },
            {
              key: "federated",
              label: "Allow federation",
              desc: "Allow rooms to federate with external Matrix servers",
            },
            {
              key: "guestAccess",
              label: "Allow guest access",
              desc: "Permit unauthenticated guest users in public rooms",
            },
          ].map((f) => (
            <div key={f.key} className="ss-setting-row">
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">{f.label}</div>
                <div className="ss-setting-row__desc">{f.desc}</div>
              </div>
              <div className="ss-setting-row__control">
                <Toggle
                  checked={!!cfg[f.key]}
                  onChange={(v) => onChange(f.key, v)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ─── 3. Files ─────────────────────────────────────────────────────────────────
function FilesTab({ cfg, onChange }) {
  const [typeInput, setTypeInput] = useState("");
  const addType = () => {
    if (
      typeInput.trim() &&
      !cfg.allowedTypes.includes(typeInput.toUpperCase())
    ) {
      onChange("allowedTypes", [
        ...cfg.allowedTypes,
        typeInput.toUpperCase().trim(),
      ]);
      setTypeInput("");
    }
  };
  const removeType = (t) =>
    onChange(
      "allowedTypes",
      cfg.allowedTypes.filter((x) => x !== t),
    );

  return (
    <>
      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(249,115,22,0.10)", color: "#F97316" }}
          >
            {Ico.Files}
          </div>
          <div>
            <div className="ss-card__header-title">Upload Limits</div>
            <div className="ss-card__header-subtitle">
              Control maximum file sizes and allowed file types
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-form-grid" style={{ marginBottom: 16 }}>
            <div className="ss-field">
              <label>Max Upload Size (MB)</label>
              <input
                className="ss-input"
                type="number"
                min="1"
                max="500"
                value={cfg.maxSizeMb}
                onChange={(e) => onChange("maxSizeMb", e.target.value)}
              />
            </div>
            <div className="ss-field">
              <label>Thumbnail Resolution</label>
              <select
                className="ss-select"
                value={cfg.thumbnailSize}
                onChange={(e) => onChange("thumbnailSize", e.target.value)}
              >
                {["480x480", "800x800", "1024x1024"].map((s) => (
                  <option key={s}>{s}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="ss-field">
            <label>Allowed File Types</label>
            <div className="ss-tags">
              {cfg.allowedTypes.map((t) => (
                <span key={t} className="ss-tags__tag">
                  {t}
                  <button onClick={() => removeType(t)}>{Ico.XCircle}</button>
                </span>
              ))}
              <input
                className="ss-input"
                style={{
                  flex: 1,
                  minWidth: 90,
                  border: "none",
                  background: "transparent",
                  boxShadow: "none",
                  padding: "2px 6px",
                }}
                value={typeInput}
                onChange={(e) => setTypeInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && addType()}
                placeholder="+ Type (Enter)"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(239,68,68,0.10)", color: "#EF4444" }}
          >
            {Ico.Files}
          </div>
          <div>
            <div className="ss-card__header-title">Antivirus & Quarantine</div>
            <div className="ss-card__header-subtitle">
              Automatic scanning policy for uploaded files
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          {[
            {
              key: "avScan",
              label: "Enable antivirus scanning",
              desc: "Scan every upload with the configured AV engine before delivery",
            },
            {
              key: "autoQuarantine",
              label: "Auto-quarantine on detection",
              desc: "Move flagged files to quarantine automatically",
            },
            {
              key: "notifyAdmin",
              label: "Notify admin on quarantine",
              desc: "Send a portal alert when a file is quarantined",
            },
          ].map((f) => (
            <div key={f.key} className="ss-setting-row">
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">{f.label}</div>
                <div className="ss-setting-row__desc">{f.desc}</div>
              </div>
              <div className="ss-setting-row__control">
                <Toggle
                  checked={!!cfg[f.key]}
                  onChange={(v) => onChange(f.key, v)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ─── 4. Notifications ─────────────────────────────────────────────────────────
function NotificationsTab({ cfg, onChange }) {
  const templates = [
    {
      key: "newMessage",
      label: "New Message",
      desc: "Sent when user receives a new message",
      icon: "💬",
      color: "#0062FE",
      bg: "rgba(0,98,254,0.10)",
    },
    {
      key: "broadcast",
      label: "Broadcast",
      desc: "Sent when an official announcement is posted",
      icon: "📢",
      color: "#8B5CF6",
      bg: "rgba(139,92,246,0.10)",
    },
    {
      key: "fileShared",
      label: "File Shared",
      desc: "Sent when a file is shared in a room",
      icon: "📎",
      color: "#F97316",
      bg: "rgba(249,115,22,0.10)",
    },
    {
      key: "mention",
      label: "Mention",
      desc: "Sent when a user is mentioned",
      icon: "🔔",
      color: "#22C55E",
      bg: "rgba(34,197,94,0.10)",
    },
    {
      key: "securityAlert",
      label: "Security Alert",
      desc: "Critical security events and admin actions",
      icon: "🔒",
      color: "#EF4444",
      bg: "rgba(239,68,68,0.10)",
    },
  ];

  return (
    <>
      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(0,98,254,0.10)", color: "#0062FE" }}
          >
            {Ico.Notif}
          </div>
          <div>
            <div className="ss-card__header-title">Push Gateway</div>
            <div className="ss-card__header-subtitle">
              FCM (Android) and APNs (iOS) push service configuration
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-form-grid" style={{ marginBottom: 16 }}>
            <div className="ss-setting-row" style={{ paddingTop: 0 }}>
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">FCM (Android)</div>
                <div className="ss-setting-row__desc">
                  Firebase Cloud Messaging for Android devices
                </div>
              </div>
              <div className="ss-setting-row__control">
                <span className="ss-status ss-status--healthy">Active</span>
                <Toggle
                  checked={cfg.fcmEnabled}
                  onChange={(v) => onChange("fcmEnabled", v)}
                />
              </div>
            </div>
            <div className="ss-setting-row" style={{ paddingTop: 0 }}>
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">APNs (iOS)</div>
                <div className="ss-setting-row__desc">
                  Apple Push Notification service for iOS devices
                </div>
              </div>
              <div className="ss-setting-row__control">
                <span className="ss-status ss-status--healthy">Active</span>
                <Toggle
                  checked={cfg.apnsEnabled}
                  onChange={(v) => onChange("apnsEnabled", v)}
                />
              </div>
            </div>
          </div>
          <TokenField
            label="FCM Server Key"
            value={cfg.fcmKey}
            onChange={(v) => onChange("fcmKey", v)}
            onRotate={() => alert("Rotating FCM key…")}
          />
          <TestConnection label="FCM Gateway" />
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(249,115,22,0.10)", color: "#F97316" }}
          >
            {Ico.Notif}
          </div>
          <div>
            <div className="ss-card__header-title">Quiet Hours</div>
            <div className="ss-card__header-subtitle">
              Suppress non-critical push notifications during specified hours
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-setting-row" style={{ paddingTop: 0 }}>
            <div className="ss-setting-row__info">
              <div className="ss-setting-row__label">Enable Quiet Hours</div>
              <div className="ss-setting-row__desc">
                Security alerts will still be delivered during quiet hours
              </div>
            </div>
            <Toggle
              checked={cfg.quietHours}
              onChange={(v) => onChange("quietHours", v)}
            />
          </div>
          {cfg.quietHours && (
            <div className="ss-form-grid" style={{ marginTop: 12 }}>
              <div className="ss-field">
                <label>Start Time</label>
                <input
                  className="ss-input"
                  type="time"
                  value={cfg.quietStart}
                  onChange={(e) => onChange("quietStart", e.target.value)}
                />
              </div>
              <div className="ss-field">
                <label>End Time</label>
                <input
                  className="ss-input"
                  type="time"
                  value={cfg.quietEnd}
                  onChange={(e) => onChange("quietEnd", e.target.value)}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(34,197,94,0.10)", color: "#22C55E" }}
          >
            {Ico.Notif}
          </div>
          <div>
            <div className="ss-card__header-title">Notification Templates</div>
            <div className="ss-card__header-subtitle">
              Enable or disable individual push notification types
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          {templates.map((t) => (
            <div key={t.key} className="ss-notif-row">
              <div
                className="ss-notif-row__icon"
                style={{ background: t.bg, color: t.color }}
              >
                {t.icon}
              </div>
              <div className="ss-notif-row__info">
                <div className="ss-notif-row__name">{t.label}</div>
                <div className="ss-notif-row__desc">{t.desc}</div>
              </div>
              <div className="ss-notif-row__controls">
                <span
                  className="ss-status ss-status--active"
                  style={{ fontSize: 11 }}
                >
                  Active
                </span>
                <Toggle
                  checked={!!cfg.templates?.[t.key] !== false}
                  onChange={(v) =>
                    onChange("templates", { ...cfg.templates, [t.key]: v })
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ─── 5. WhatsApp ─────────────────────────────────────────────────────────────
function WhatsAppTab({ cfg, onChange }) {
  return (
    <>
      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(34,197,94,0.10)", color: "#22C55E" }}
          >
            {Ico.WhatsApp}
          </div>
          <div>
            <div className="ss-card__header-title">Webhook Configuration</div>
            <div className="ss-card__header-subtitle">
              Incoming WhatsApp webhook endpoint and verification
            </div>
          </div>
          <div className="ss-card__header-actions">
            <span className="ss-status ss-status--healthy">Active</span>
          </div>
        </div>
        <div className="ss-card__body">
          <div
            className="ss-form-grid ss-form-grid--full"
            style={{ marginBottom: 16 }}
          >
            <div className="ss-field">
              <label>Webhook URL</label>
              <input
                className="ss-input"
                value={cfg.webhookUrl}
                onChange={(e) => onChange("webhookUrl", e.target.value)}
                placeholder="https://api.murasal.local/webhooks/whatsapp"
              />
            </div>
          </div>
          <TokenField
            label="Webhook Verify Token"
            value={cfg.verifyToken}
            onChange={(v) => onChange("verifyToken", v)}
            onRotate={() => alert("Rotating verify token…")}
          />
          <TokenField
            label="Access Token"
            value={cfg.accessToken}
            onChange={(v) => onChange("accessToken", v)}
            onRotate={() => alert("Rotating access token…")}
          />
          <div className="ss-form-grid" style={{ marginTop: 14 }}>
            <div className="ss-field">
              <label>Token Expiry</label>
              <span
                className="ss-status ss-status--expiring"
                style={{ display: "inline-flex", marginTop: 6 }}
              >
                Expiring in 12 days
              </span>
            </div>
            <div className="ss-field">
              <label>Phone Number ID</label>
              <input
                className="ss-input"
                value={cfg.phoneNumberId}
                onChange={(e) => onChange("phoneNumberId", e.target.value)}
                placeholder="1234567890"
              />
            </div>
          </div>
          <TestConnection label="WhatsApp Webhook" />
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(0,98,254,0.10)", color: "#0062FE" }}
          >
            {Ico.WhatsApp}
          </div>
          <div>
            <div className="ss-card__header-title">Media & Limits</div>
            <div className="ss-card__header-subtitle">
              Control WhatsApp media download behaviour
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-form-grid" style={{ marginBottom: 16 }}>
            <div className="ss-field">
              <label>Max Media Download (MB)</label>
              <input
                className="ss-input"
                type="number"
                min="1"
                max="100"
                value={cfg.maxMediaMb}
                onChange={(e) => onChange("maxMediaMb", e.target.value)}
              />
            </div>
            <div className="ss-field">
              <label>Default Routing Room</label>
              <select
                className="ss-select"
                value={cfg.defaultRoom}
                onChange={(e) => onChange("defaultRoom", e.target.value)}
              >
                {[
                  "— None —",
                  "Operations Command",
                  "Port Security Updates",
                  "Logistics Team",
                ].map((r) => (
                  <option key={r}>{r}</option>
                ))}
              </select>
            </div>
          </div>
          {[
            {
              key: "autoDownloadMedia",
              label: "Auto-download media files",
              desc: "Automatically download images, audio and documents from WhatsApp",
            },
            {
              key: "logRejected",
              label: "Log rejected messages",
              desc: "Store metadata for messages that could not be routed",
            },
            {
              key: "notifyOnFailure",
              label: "Alert admin on routing failure",
              desc: "Send a portal alert when a message fails to route",
            },
          ].map((f) => (
            <div key={f.key} className="ss-setting-row">
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">{f.label}</div>
                <div className="ss-setting-row__desc">{f.desc}</div>
              </div>
              <Toggle
                checked={!!cfg[f.key]}
                onChange={(v) => onChange(f.key, v)}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ─── 6. Retention ────────────────────────────────────────────────────────────
function RetentionTab({ cfg, onChange }) {
  const tiers = [
    { key: "msgPrivate", label: "Private Room Messages", unit: "days" },
    { key: "msgBroadcast", label: "Broadcast Room Messages", unit: "days" },
    { key: "filesPrivate", label: "Private Room Files", unit: "days" },
    { key: "filesBroadcast", label: "Broadcast Room Files", unit: "days" },
    { key: "auditLogs", label: "Audit Log Events", unit: "days" },
    { key: "mediaThumb", label: "Media Thumbnails", unit: "days" },
  ];
  return (
    <>
      <div className="ss-impact-banner ss-impact-banner--danger">
        {Ico.Warn}
        <span>
          <strong>Warning:</strong> Reducing retention periods will permanently
          delete older messages and files. This action cannot be undone. Test on
          UAT first.
        </span>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(6,182,212,0.10)", color: "#06B6D4" }}
          >
            {Ico.Retain}
          </div>
          <div>
            <div className="ss-card__header-title">Retention Periods</div>
            <div className="ss-card__header-subtitle">
              Set how long each data type is retained. 0 = indefinite.
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          <div className="ss-retention-grid">
            {tiers.map((t) => (
              <div key={t.key} className="ss-retention-card">
                <div className="ss-retention-card__type">{t.label}</div>
                <div className="ss-retention-card__days">
                  {cfg[t.key] || "365"}
                </div>
                <div className="ss-retention-card__unit">{t.unit}</div>
                <input
                  className="ss-retention-card__input"
                  type="number"
                  min="0"
                  max="3650"
                  value={cfg[t.key] || "365"}
                  onChange={(e) => onChange(t.key, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="ss-card">
        <div className="ss-card__header">
          <div
            className="ss-card__header-icon"
            style={{ background: "rgba(239,68,68,0.10)", color: "#EF4444" }}
          >
            {Ico.Retain}
          </div>
          <div>
            <div className="ss-card__header-title">Deletion Policy</div>
            <div className="ss-card__header-subtitle">
              How expired data is handled
            </div>
          </div>
        </div>
        <div className="ss-card__body">
          {[
            {
              key: "softDelete",
              label: "Soft delete first",
              desc: "Move expired data to a deletion queue before hard-deleting after 7 days",
            },
            {
              key: "notifyBeforeDel",
              label: "Notify admin before deletion",
              desc: "Send a portal alert 7 days before data is permanently deleted",
            },
            {
              key: "exportBeforeDel",
              label: "Auto-export before deletion",
              desc: "Export expired data to object storage archive before deleting",
            },
          ].map((f) => (
            <div key={f.key} className="ss-setting-row">
              <div className="ss-setting-row__info">
                <div className="ss-setting-row__label">{f.label}</div>
                <div className="ss-setting-row__desc">{f.desc}</div>
              </div>
              <Toggle
                checked={!!cfg[f.key]}
                onChange={(v) => onChange(f.key, v)}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════════════
const TABS = [
  { id: "mobile", label: "Mobile App", icon: Ico.Mobile },
  { id: "matrix", label: "Matrix", icon: Ico.Matrix },
  { id: "files", label: "Files", icon: Ico.Files },
  { id: "notif", label: "Notifications", icon: Ico.Notif },
  { id: "whatsapp", label: "WhatsApp", icon: Ico.WhatsApp },
  { id: "retention", label: "Retention", icon: Ico.Retain },
];

const DEFAULT_CONFIG = {
  mobile: {
    minVersion: "1.0.0",
    latestVersion: "1.3.2",
    maintenanceMode: false,
    maintenanceMsg: "",
    features: {
      fileSharing: true,
      voiceNotes: true,
      reactions: true,
      screenshotPrev: false,
      biometricAuth: true,
    },
  },
  matrix: {
    homeserverUrl: "https://matrix.internal",
    serverName: "murasal.local",
    adminToken: "syt_YWRtaW4_XXXXXXXXXXXXXXXX_XXXXXX",
    defaultRoomVersion: "10",
    historyVisibility: "shared",
    encryptByDefault: true,
    federated: false,
    guestAccess: false,
  },
  files: {
    maxSizeMb: "50",
    thumbnailSize: "800x800",
    allowedTypes: ["PDF", "JPG", "PNG", "XLSX", "DOCX", "MP4"],
    avScan: true,
    autoQuarantine: true,
    notifyAdmin: true,
  },
  notif: {
    fcmEnabled: true,
    apnsEnabled: true,
    fcmKey: "AAAA_FCM_SERVER_KEY_PLACEHOLDER",
    quietHours: false,
    quietStart: "23:00",
    quietEnd: "06:00",
    templates: {
      newMessage: true,
      broadcast: true,
      fileShared: true,
      mention: true,
      securityAlert: true,
    },
  },
  whatsapp: {
    webhookUrl: "https://api.murasal.local/webhooks/whatsapp",
    verifyToken: "murasal_verify_token_2024",
    accessToken: "EAAxxxxxxxx",
    phoneNumberId: "1234567890",
    maxMediaMb: "20",
    defaultRoom: "Operations Command",
    autoDownloadMedia: true,
    logRejected: true,
    notifyOnFailure: true,
  },
  retention: {
    msgPrivate: "365",
    msgBroadcast: "365",
    filesPrivate: "180",
    filesBroadcast: "365",
    auditLogs: "730",
    mediaThumb: "90",
    softDelete: true,
    notifyBeforeDel: true,
    exportBeforeDel: false,
  },
};

const SystemSetting = () => {
  const [activeTab, setActiveTab] = useState("mobile");
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [dirty, setDirty] = useState({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const handleChange = useCallback((tab, key, value) => {
    setConfig((prev) => ({ ...prev, [tab]: { ...prev[tab], [key]: value } }));
    setDirty((prev) => ({ ...prev, [tab]: true }));
    setSaved(false);
  }, []);

  const makeChanger = (tab) => (key, value) => handleChange(tab, key, value);

  const handleSave = async () => {
    setSaving(true);
    await new Promise((r) => setTimeout(r, 900));
    setSaving(false);
    setSaved(true);
    setDirty({});
    setTimeout(() => setSaved(false), 3000);
  };

  const hasUnsaved = Object.keys(dirty).length > 0;

  const renderTab = () => {
    switch (activeTab) {
      case "mobile":
        return (
          <MobileTab
            cfg={config.mobile}
            onChange={makeChanger("mobile")}
            dirty={dirty.mobile}
          />
        );
      case "matrix":
        return (
          <MatrixTab cfg={config.matrix} onChange={makeChanger("matrix")} />
        );
      case "files":
        return <FilesTab cfg={config.files} onChange={makeChanger("files")} />;
      case "notif":
        return (
          <NotificationsTab
            cfg={config.notif}
            onChange={makeChanger("notif")}
          />
        );
      case "whatsapp":
        return (
          <WhatsAppTab
            cfg={config.whatsapp}
            onChange={makeChanger("whatsapp")}
          />
        );
      case "retention":
        return (
          <RetentionTab
            cfg={config.retention}
            onChange={makeChanger("retention")}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="ss-page">
      {/* ── Header ── */}
      <div className="ss-header">
        <div className="ss-header__left">
          <span className="ss-header__label">System</span>
          <h1 className="ss-header__title">System Settings</h1>
          <p className="ss-header__subtitle">
            Manage global configuration for mobile app, Matrix, files,
            notifications, WhatsApp and retention
          </p>
        </div>
        <div className="ss-header__right">
          <span className="ss-env-badge ss-env-badge--production">
            Production
          </span>
          <button
            className="ss-btn ss-btn--secondary"
            onClick={() => {
              setConfig(DEFAULT_CONFIG);
              setDirty({});
            }}
          >
            {Ico.Refresh} Reset
          </button>
          <button
            className="ss-btn ss-btn--primary"
            onClick={handleSave}
            disabled={saving || !hasUnsaved}
          >
            {saving ? (
              <>{Ico.Spinner} Saving…</>
            ) : saved ? (
              <>{Ico.Check} Saved</>
            ) : (
              <>{Ico.Save} Save Changes</>
            )}
          </button>
        </div>
      </div>

      {/* ── Tabs ── */}
      <div className="ss-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={`ss-tab${activeTab === t.id ? " active" : ""}`}
            onClick={() => setActiveTab(t.id)}
          >
            {t.icon} {t.label}
            {dirty[t.id] && (
              <span
                style={{
                  width: 6,
                  height: 6,
                  background: "#F97316",
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              />
            )}
          </button>
        ))}
      </div>

      {/* ── Tab Content ── */}
      {renderTab()}

      {/* ── Unsaved changes bar ── */}
      {hasUnsaved && !saving && (
        <div className="ss-unsaved-bar-systemsetting">
          {Ico.Warn}
          <span>
            You have unsaved changes in:{" "}
            <strong>
              {Object.keys(dirty)
                .map((k) => TABS.find((t) => t.id === k)?.label)
                .join(", ")}
            </strong>
          </span>
          <button
            className="ss-btn ss-btn--primary"
            style={{ padding: "7px 16px", fontSize: 13 }}
            onClick={handleSave}
          >
            {Ico.Save} Save All
          </button>
          <button
            className="ss-btn ss-btn--ghost"
            style={{ color: "#fff", padding: "7px 12px", fontSize: 13 }}
            onClick={() => {
              setConfig(DEFAULT_CONFIG);
              setDirty({});
            }}
          >
            Discard
          </button>
        </div>
      )}
    </div>
  );
};

export default SystemSetting;
